// AddTodo.js

import React, { useState } from 'react';

export const AddTodo = (props) => {
    const [title, setTitle] = useState("");
    const [desc, setDesc] = useState("");

    const submit = (e)=>{
        e.preventDefault();//page will not reload
        if(!title){ //if(!title || !desc){
            alert("Note Title cannot be empty!");
        }
        else{
            props.addTodo(title, desc);
            setTitle("");
            setDesc("");
        }
        
    }

    return (
        <div className="container my-3">
            <h3>Add a note</h3>
            <form onSubmit={submit}>
                <div className="mb-3">
                    <label htmlFor="title" className="form-label">Note title</label>
                    <input type="text" value={title} onChange={(e)=>setTitle(e.target.value)} className="form-control" id="title" aria-describedby="emailHelp"/>
                        
  </div>
                    <div className="mb-3">
                        <label htmlFor="desc" className="form-label">Note</label>
                        <input type="text" value={desc} onChange={(e)=>setDesc(e.target.value)} className="form-control" id="desc"/>
  </div>
         <button type="submit" className="btn btn-sm btn-success">Add Note</button>
</form>
                </div>
                    )
}
